// src/utils/debug.ts

import { devTraceAutoplayPolicy } from "./autoplayPolicy";

// By default, no-op
export let log: (...args: any[]) => void = () => {};
export let warn: (...args: any[]) => void = () => {};
export let error: (...args: any[]) => void = () => {};

export function enableDebugLogging() {
  devTraceAutoplayPolicy(true);

  // Enable logging
  log = (...args: any[]) => {
    try { console.log("[debug]", ...args); } catch {}
  };
  warn = (...args: any[]) => {
    try { console.warn("[warn]", ...args); } catch {}
  };
  error = (...args: any[]) => {
    try { console.error("[error]", ...args); } catch {}
  };
}